import { render } from "./SoftwareDev.vue?vue&type=template&id=0bcd65b1&scoped=true"
import script from "./SoftwareDev.vue?vue&type=script&lang=js"
export * from "./SoftwareDev.vue?vue&type=script&lang=js"

import "./SoftwareDev.vue?vue&type=style&index=0&id=0bcd65b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcd65b1"]])

export default __exports__